import React from "react";
import { WebcastEntry } from "@kaltura/mediaspace-shared-types";
import styled from "@emotion/styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";
import { Link, Typography } from "@kaltura/ds-react-components";
import { EventListContainer } from "@kaltura/mediaspace-shared-event-platform-event-list";
import SessionsList from "./SessionsList";
import { TruncateWithTooltip } from "@kaltura/mediaspace-shared-ui";

const CLASS_NAME_PREFIX = "kms-ds-homepage-component";

export interface ScheduledSessionsProps {
    sessions: WebcastEntry[];
    headerText?: string;
    linkToSessionsText?: string;
    linkToSessionsUrl?: string;
    // Is event list items disabled
    disabledMode?: boolean;
    calendarEntriesToken?: string;
}

const ScheduledSessionsContainer = styled("div")(systemWidth);

const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: theme.spacing(3),
}));

/**
 *  ScheduledSessions component renders scheduled sessions from playlist or category
 */
export const ScheduledSessions = ({
    sessions,
    headerText,
    linkToSessionsText,
    linkToSessionsUrl,
    disabledMode = false,
    calendarEntriesToken,
}: ScheduledSessionsProps) => {
    const linkContent =
        linkToSessionsText
        && (linkToSessionsUrl ? (
            <Link
                href={linkToSessionsUrl}
                target={"_blank"}
                size={"small"}
                className={`${CLASS_NAME_PREFIX}-ScheduledSessions-header-link`}
            >
                {linkToSessionsText}
            </Link>
        ) : (
            <Typography variant={"buttonLabel1"} className={`${CLASS_NAME_PREFIX}-ScheduledSessions-header-link-text`}>
                {linkToSessionsText}
            </Typography>
        ));

    return (
        <ScheduledSessionsContainer className={`${CLASS_NAME_PREFIX}-ScheduledSessions`}>
            {(headerText || linkContent) && (
                <TitleContainer className={`${CLASS_NAME_PREFIX}-ScheduledSessions-titleContainer`}>
                    <TruncateWithTooltip text={headerText} lines={1}>
                        <Typography variant={"h3"} className={`${CLASS_NAME_PREFIX}-ScheduledSessions-header`}>
                            {headerText}
                        </Typography>
                    </TruncateWithTooltip>
                    {linkContent && (
                        <TruncateWithTooltip text={headerText} lines={1}>
                            {linkContent}
                        </TruncateWithTooltip>
                    )}
                </TitleContainer>
            )}
            <div className={`${CLASS_NAME_PREFIX}-sessions-list`}>
                <EventListContainer
                    disabledMode={disabledMode}
                    sessions={sessions}
                    eventListComponent={<SessionsList calendarEntriesToken={calendarEntriesToken} />}
                />
            </div>
        </ScheduledSessionsContainer>
    );
};

export default ScheduledSessions;
